import script from "./NotYetOpen.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotYetOpen.vue?vue&type=script&lang=ts&setup=true"

import "./NotYetOpen.vue?vue&type=style&index=0&id=71d79e56&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d79e56"]])

export default __exports__